import { createFileRoute } from '@tanstack/react-router';
import CharacterRetirements from 'src/pages/Organization/Reports/CharacterRetirements';

export const Route = createFileRoute(
  '/$organizationSlug/reports/character_retirements/',
)({
  component: CharacterRetirements,
});
